import { defineStore } from "pinia";

interface State {
  isShowTurnVipModal: boolean;
  vipType: number;
  btnDesc: string;
  needTypeVip: number;
}

export const useTurnVipStore = defineStore("changeModel", {
  state: (): State => ({
    isShowTurnVipModal: false,
    vipType: 0, // 1 8 9月会员
    btnDesc: "",
    needTypeVip: 0,
  }),
  actions: {
    update_isShowTurnVipModal(payload: any) {
      this.vipType = payload.vipType;
      this.needTypeVip = payload.needTypeVip || 0;
      console.log(888, payload);
      // if (!payload.vipType) {
      //   router.push({ name: "VIP" });
      //   return;
      // }
      if ([1, 8, 9].includes(payload.needTypeVip)) {
        this.btnDesc = "$12.90 / Month";
      } else {
        this.btnDesc = "$ 2.99 / Week";
      }
      this.isShowTurnVipModal = payload.isShow;
    },
  },
});
